<template>
  <div>

    <!--   Containers filter-->
    <b-card>
      <b-card-title>{{ $t('Containers filters')}}</b-card-title>
      <b-row>
        <b-col md="12">
          <b-form-group :label="$t('Owners')">
            <v-select multiple :close-on-select="false" v-model="selectedOwners"
                      :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                      :getOptionLabel="o => o.name"
                      :options="ownersFilter"
                      :reduce="o => o.id" />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group :label="$t('Contracts')">
            <v-select multiple :close-on-select="false" v-model="request.data.contracts"
                      :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                      :getOptionLabel="c => c.name"
                      :options="contractsOptions"
                      :reduce="c => c.id" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <!--    report form-->
    <b-card>
      <div v-if="false" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="40" :color="'#0e96b1'" />
      </div>

      <b-form @submit.prevent="submitReport">
        <b-row>
          <b-col md="12">
            <b-form-group :label="`${$t('Period')}`">
              <v-select v-model="request.data.period"
                        :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                        :getOptionLabel="i => i.label"
                        :reduce="i => i.key"
                        :options="periods"
              />
              <small v-if="error && ('period' in error)" class="text-danger">
                {{ $t(error['period'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col  cols="12">
            <b-button type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <div v-if="1">
      <b-card>

        <div v-if="!request.state" class="loading_page">
          <orbit-spinner :animation-duration="1000" :size="40" :color="'#0e96b1'" />
        </div>

        <b-row>

          <b-col cols="2" md="2" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <v-select v-model="perPage" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                      :options="[5,25, 50, 100, 200, 500]" :clearable="false"
                      class="per-page-selector d-inline-block mx-50" />
            <label>{{ $t('entries') }}</label>
          </b-col>

          <b-col cols="12" md="12" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">

            <div class="col-12 mb-1 d-flex justify-content-end">
              <!--            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" @click.prevent="Print" type="button"-->
              <!--                      variant="primary" class="mr-1 btn-sm">-->
              <!--              {{ $t('print') }}-->
              <!--            </b-button>-->
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" @click.prevent="export_file('pdf')"
                        type="button" variant="primary" class="mr-1 btn-sm">
                {{ $t('pdf') }}
              </b-button>

              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" @click.prevent="export_file('xlsx')"
                        type="button" variant="primary" class="mr-1 btn-sm">
                {{ $t('Excel') }}
              </b-button>
            </div>

          </b-col>
          <b-table class="table table-sm"
                   show-empty
                   bordered
                   :per-page="perPage"
                   :current-page="currentPage"
                   responsive
                   small
                   :empty-text="$t('no data found')"
                   :fields="fields.map((i) => ({ key: i.key, label: $t(i.label), sortable: i.sortable }))"
                   :items="reportResult">

          </b-table>
        </b-row>

        <b-row class=" mb-2 mt-2">
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{ $t('Showing From') }}  {{ paginationText.start }} {{ $t('to') }} {{ paginationText.end }} {{ $t('of') }} {{ reportResult.length }}
                {{ $t('entries') }}</span>
          </b-col>
          <!-- Pagination -->

          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination v-model="currentPage" :total-rows="reportResult.length" :per-page="perPage"
                          first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>

      </b-card>
    </div>

  </div>

</template>


<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, BLink, BMedia, BCardTitle,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, computed, reactive } from '@vue/composition-api'

import Cleave from 'vue-cleave-component'
import DevicesListFilters from '../filters/DevicesListFilters.vue'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
import DataTable from '@/views/reports/data-table/DataTable.vue'
import axios from '@/libs/axios'
import fields from '@/views/reports/non-liftedContainers/fields'
import { createToastInterface } from 'vue-toastification'

export default {
  name: 'CompactorReport',
  components: {
    BCardTitle,
    BRow, BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert, BFormGroup, BFormInput, flatPickr,
    BFormCheckbox, BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    Cleave,
    BLink,
    BMedia,
    ToggleCollapse, DevicesListFilters,
    DataTable
  },
  directives: { Ripple, },

  setup() {

    const perPage = ref(25)
    const currentPage = ref(1)

    const error = ref(null)

    const selectedOwners = ref([])
    const selectedContracts = ref([])
    const periods = [{key: "last24h", label: "أخر 24 ساعة"}, {key: "lastTwoDays", label: "أخر 48 ساعة"},
      {key: "lastWeek", label: "أخر 7 أيام"},  {key: "all", label: "قبل 24 ساعة"}]

    const contractsOptions = computed(() => {
      request.data.owners = selectedOwners.value
      return contractsFilter.value.filter(i =>
          selectedOwners.value.includes(i.contractor_id))
    })

    const ownersFilter =  ref([])
    const contractsFilter =  ref([])

    const reportResult = ref([])

    const paginationText = computed(() => {
      const start = (currentPage.value - 1) * perPage.value + 1
      const end = Math.min(currentPage.value * perPage.value, reportResult.value.length)
      return { start: end > 1 ? start : 0, end}
    })

    const request = reactive({
      data: {
        type: "nonLiftedContainers",
        needPagination: false,
        period: '',
        contracts :[],
        owners: [],
        types:[]
      },
      state: true
    })

    const pluginOptions = {
      position: "bottom-right",
      timeout: false,
      closeOnClick: false,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: false,
      draggablePercent: 0.12,
      showCloseButtonOnHover: false,
      hideProgressBar: true,
      closeButton: false,
      icon: true,
      rtl: false
    }

    const toast = createToastInterface(pluginOptions)

    axios.get('filters/getFilterBy', { params: {
        type: 'container'}})
        .then(res => {
          ownersFilter.value = res.data.data.owners
          contractsFilter.value = res.data.data.contracts
        })
        .catch(e => {})


    const submitReport = () => {

      request.state = false

      axios.post('reports', request.data).then(response => {
        if (response.status === 200) {
          error.value = null
          reportResult.value = response.data.data
        }
      }).catch(e => {
        if (e.response.status === 422) {
          error.value = e.response.data.errors
          console.log(error.value)
        }
      }).finally(_ => request.state = true)

    }

    const export_status = ref(false)

    const export_file = type => {

      toast.info('جاري تحميل الملف ...')
      request.state = false

      axios.post(
          'export',
          { exporter: type, export: "nonLiftedContainersReport", ...request.data },
          {responseType: 'blob'}
      )

          .then(res => {
            const blob = new Blob(
                [res.data],
                { type: res.headers['content-type'], encoding: 'UTF-8' }
            );
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `nonLiftedContainers_report.${type}`;
            link.click();
            URL.revokeObjectURL(url);
          })

          .catch(e => console.log('error export report'))
          .finally(_ => {
            request.state = true
            toast.clear()
          })

    }


    return {

      paginationText,
      perPage, currentPage,
      fields,

      periods,
      request,
      ownersFilter,
      selectedOwners,
      selectedContracts,
      contractsOptions,

      submitReport, export_file,

      reportResult,
      error


    }

  },



}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
